import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/react/react/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../packages/react/src/Button/IconButton.docs.json';
import DeprecationBanner from '../components/DeprecationBanner';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <DeprecationBanner replacementUrl={'/components/icon-button/react/latest'} mdxType="DeprecationBanner" />
    <h2>{`Usage`}</h2>
    <h3>{`Installation`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {IconButton} from '@primer/react'
`}</code></pre>
    <h3>{`Icon only button`}</h3>
    <p>{`A separate component called `}<inlineCode parentName="p">{`IconButton`}</inlineCode>{` is used if the action shows only an icon with no text. This button will remain square in shape.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<IconButton aria-label="Search" icon={SearchIcon} />
`}</code></pre>
    <h3>{`Different sized icon buttons`}</h3>
    <p><inlineCode parentName="p">{`IconButton`}</inlineCode>{` also supports the three different sizes. `}<inlineCode parentName="p">{`small`}</inlineCode>{`, `}<inlineCode parentName="p">{`medium`}</inlineCode>{`, `}<inlineCode parentName="p">{`large`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <IconButton aria-label="Search" icon={SearchIcon} size="small" />
  <IconButton aria-label="Search" sx={{ml: 2}} icon={SearchIcon} />
  <IconButton aria-label="Search" sx={{ml: 2}} icon={SearchIcon} size="large" />
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Component status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      